import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {EvkMapasComponent} from "../evk-mapas/evk-mapas.component";
import {FormBuilder, FormGroup} from "@angular/forms";
import {EvkMapasService} from "../evk-mapas/evk-mapas.service";
import {CroquisSizeConfig} from "../evk-mapas/mapas/modelos/CroquisSizeConfig";
import {BusquedaEstructuradaNominatim} from "../evk-mapas/mapas/modelos/BusquedaEstructuradaNominatim";
import {PasoWizard} from "../../../../interface/wizard-informacion.types";
import {Punto} from "../evk-mapas/mapas/modelos/Punto";
import {EvkSeccionModel} from "../../../../../expediente/models/evk-seccion.model";
import {takeUntil} from "rxjs/operators";
import {DatosSeccionWizardEventsService} from "../../../../services/datos-seccion-wizard-events.service";
import {WizardEventsService} from "../../../../services/wizard-events.service";
import {Subject} from "rxjs";
import {DataWizardService} from "../../../../services/data-wizard.service";
import {ButtonControlService} from "../../../../services/button-control.service";
import { MatSelectChange } from '@angular/material/select';
import {MessageCrudService} from "@evomatik/evk-common";
import {Marcador} from "../evk-mapas/mapas/modelos/Marcador";

@Component({
    selector: 'mapas-container',
    templateUrl: './mapas-container.component.html',
    styleUrls: ['./mapas-container.component.css']
})
export class MapasContainerComponent implements OnInit, OnDestroy {

    @ViewChild(EvkMapasComponent, {static: false})
    georeferencia: EvkMapasComponent;

    @Input()
    config: PasoWizard;

    @Input()
    paso: PasoWizard;

    @Input()
    readOnly: boolean = false;

    @Output()
    updatePositionMarker: EventEmitter<Object>;

    img64: string;

    form: FormGroup;

    punto: Punto;

    @Input()
    initPoint: Punto;

    private _unsubscribeAll: Subject<any>;

    filters = [
        {
            id: 'municipio',
            title: 'Municipio',
            path: 'municipio',
        },
        {
            id: 'cp',
            title: 'Código Postal',
            path: 'cp',
        },
    ];
    filtroSeleccionado: String;

    get getFormValue(): any {
        return this.form.value;
    }

    /**
     * Constructor
     */
    constructor(
                public datosSeccionWizard: DatosSeccionWizardEventsService,
                private buttonControlService: ButtonControlService,
                private wizardEventsService: WizardEventsService,
                public dataWizardService: DataWizardService,
                private mapaServie: EvkMapasService,
                private messageService: MessageCrudService,
                public fb: FormBuilder) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            estado: ['Chihuahua'],
            municipio: [''],
            cp: ['']
        });
        this.mapaServie.dataLatLng.subscribe(data => {

            this.updatePositionMarker.next({
                event: "fromMaps",
                data: data
            });
            if (data['lat'] && data['lng']) {
                this.onSelectionChanged(data);
            }
        });
    }

    public searchValid() {
        if(!this.filtroSeleccionado){
            return true;
        } else if("municipio" === this.filtroSeleccionado){
            return this.getFormValue.municipio === "";
        } else if("cp" === this.filtroSeleccionado){
            return this.getFormValue.cp === "";
        }
    }

    onFiltroChange($event: MatSelectChange) {
        if ($event.value) {
            this.filtroSeleccionado = $event.value;
        }
        if (!$event.value) {
            this.filtroSeleccionado = undefined;
        }
    }

    public generarImagen() {
        this.georeferencia.obtenerImagenDeMapaComoPng(CroquisSizeConfig.defaultSize()).then((img) => {
            this.img64 = img;
        });
    }

    public buscarLocalizacion() {
        this.messageService.snackbarLoading('Buscando información de georeferencia...');
        if (this.getFormValue.estado == "Ciudad De México") {
            // this.busquedaParaCdmx();
        } else {
            const busqueda = new BusquedaEstructuradaNominatim();
            busqueda.estado = this.getFormValue.estado;
            busqueda.localidad = this.getFormValue.municipio;
            busqueda.cp = this.getFormValue.cp;
            this.busquedaParaProvincia(busqueda);
        }
    }

    public busquedaParaProvincia(busqueda: BusquedaEstructuradaNominatim) {

        if("municipio" === this.filtroSeleccionado){
            busqueda.cp = "";
        }
        if("cp" === this.filtroSeleccionado){
            busqueda.localidad = "";
        }
        this.georeferencia.buscarPuntoEnElMapaConBusquedaSimple(busqueda).pipe(takeUntil(this._unsubscribeAll)).subscribe((features) => {
            if (features && features.features && features.features.length > 0) {
                this.georeferencia.agregarGeoJsonFeatures(features, true);
                const punto = this.georeferencia.featuresToPoint(features);
                // this.georeferencia.getPosicionDeMarcador()
                if (punto) {
                    this.georeferencia.moverMapaAPunto(punto);
                    this.punto = punto;
                    this.onSelectionChanged(this.punto);
                }
            } else if ("cp" === this.filtroSeleccionado) {
                busqueda.cp = (parseInt(busqueda.cp) - 10).toString();
                this.busquedaParaProvincia(busqueda);
            }
        })
    }

    ngAfterViewInit() {
        this.validarInformacion();
        if(this.paso?.inData?.lng && this.paso?.inData?.lat){
            this.georeferencia.buscarPuntoEnElMapaConBusquedaEnReversa(this.paso?.inData?.lat, this.paso?.inData?.lng).subscribe((features) => {
                if (features && features.features) {
                    this.georeferencia.agregarGeoJsonFeatures(features, true);
                    const punto = this.georeferencia.featuresToPoint(features);
                    if (punto) {
                        this.georeferencia.moverMapaAPunto(punto);
                        this.punto = punto;
                    }
                }
            })
        }

        if (this.readOnly && this.initPoint !== null) {
            let punto: Punto = new Punto(this.initPoint.latitud, this.initPoint.longitud);
            let marcador: Marcador = new Marcador(punto, "");
            this.georeferencia.agregarMarker(marcador);
            this.georeferencia.moverMapaAPunto(punto);
        }
    }

    validarInformacion() {
        this.buttonControlService.cambiarBotonSiguiente(true);
        if (this.paso.inData && this.paso?.inData[this.config.nombre] !== undefined) {
            this.buttonControlService.cambiarBotonSiguiente(true);
        } else {
            this.buttonControlService.cambiarBotonSiguiente(true);
        }
    }

    onSelectionChanged(data: any, save?: boolean) {
        if(data){
            const response: EvkSeccionModel = {
                origen: this.config.nombre,
                propiedades: {
                    lat: data.lat? data.lat : data.latitud,
                    lng: data.lng? data.lng : data.longitud
                }
            }
            if (save) {
                this.datosSeccionWizard.onDoneSave.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
                    this.wizardEventsService.save();
                })
            }
            this.datosSeccionWizard.doneSave(response);
        }
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
        this._unsubscribeAll.unsubscribe();
    }
}
